import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { seeWineries } from "../../../actions/wineryActions";
import Wineries from "../../../containers/Wineries/Wineries/Wineries";

export const WineryList = ({ history }) => {
  const dispatch = useDispatch();
  const { wineriesList } = useSelector((state) => state.wineriesAdmin);
  const [codeName, setCodeName] = useState("")
  useEffect(() => {
    dispatch(seeWineries(codeName));
  }, [codeName]);
  return (
    <Wineries
      codeName={codeName}
      setCodeName={setCodeName}
      wineriesList={wineriesList}
      hadleClick={(data) =>
        history.push("/Admin/Inventory/ProductListById/" + data)
      }
    />
  );
};
